class SiblingSwatches extends HTMLElement {
  connectedCallback() {
    this.swatches = this.querySelectorAll('.color-swatch');
    this.initSwatches();
  }

  initSwatches() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const value = swatch.dataset.value;
        const variantId = swatch.dataset.variantId;
        const optionIndex = swatch.closest('[data-option-index]').dataset.optionIndex;
        
        // Update select element
        const select = this.querySelector(`#Option-${this.dataset.section}-${optionIndex}`);
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update UI
        this.swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');

        // Trigger media update
        if (variantId) {
          const mediaEvent = new CustomEvent('variant:media-change', {
            detail: { variantId: variantId }
          });
          document.dispatchEvent(mediaEvent);
        }
      });
    });
  }
}

if (!customElements.get('sibling-swatches')) {
  customElements.define('sibling-swatches', SiblingSwatches);
}